const mutations = {
    request(state) {
        state.status = 'loading'
    },
    auth_success(state, token, user) {
        state.status = 'success'
        state.token = token
        state.user = user
        state.isLoggedIn = true
    },
    auth_error(state) {
        state.status = 'error'
    },
    logout(state) {
        state.status = ''
        state.token = ''
    },
    proveedor_success(state, token, proveedor) {
        state.status = 'success'
        state.token = token
        state.proveedor = proveedor
        state.isLoggedIn = true
    },
    proveedor_error(state) {
        state.status = 'error'
    },
    orden_success(state, token, ordenCompra) {
        state.status = 'success'
        state.token = token
        state.ordenCompra = ordenCompra
        state.isLoggedIn = true
    },
    orden_error(state) {
        state.status = 'error'
    },
    transporte_success(state, token, transporte) {
        state.status = 'success'
        state.token = token
        state.transporte = transporte
        state.isLoggedIn = true
    },
    transporte_error(state) {
        state.status = 'error'
    },
    producto_success(state, token, producto) {
        state.status = 'success'
        state.token = token
        state.producto = producto
        state.isLoggedIn = true
    },
    producto_error(state) {
        state.status = 'error'
      },
      setLoading(state, isLoading) {
          state.isLoading = isLoading
      },
    'TOGGLE_WITHOUT_ANIMATION'(state, value) {
        state.sidebar.withoutAnimation = value
    },
    'AGREGAR_PRODUCTO'(state, value) {
        state.nuevaVenta.productos = [...state.nuevaVenta.productos, value]
    },
    'SET_PROVEEDORES'(state, proveedores) {
        state.proveedores = proveedores
    },
    'SET_ORDEN_COMPRA'(state, ordenCompra) {
        state.ordenCompra = ordenCompra
    },
    'SET_USUARIO'(state, usuarios) {
        state.usuarios = usuarios
    },
    'SET_TRANSPORTE'(state, transportes) {
        state.transportes = transportes
    },
    'SET_PRODUCTO'(state, productos) {
        state.productos = productos
    },
    'SET_MARCA_VEHICULO'(state, marcas) {
        state.marcas = marcas
    },
    'SET_VEHICULO_MODELO'(state, modelos) {
        state.modelos = modelos
    },
    'SET_VEHICULOS'(state, vehiculos) {
        state.vehiculos = vehiculos
    },
    'SET_CATEGORIAS'(state, categorias) {
        state.categorias = categorias
    },
    'SET_FAMILIA'(state, familias) {
        state.familias = familias
    },
    'SET_MARCA_PRODUCTO'(state, marcaProducto){
        state.marcaProducto = marcaProducto
    },
    'SET_PRODUCTO_MIRANDA'(state, productoMiranda){
      state.productoMiranda = productoMiranda
    },
    'SET_CLASIFICACION_PRODUCTO'(state, clasificacion){
        state.clasificacion = clasificacion
    },
    'SET_CLIENTE'(state, cliente){
        state.cliente = cliente
    },
    'SET_VOUCHER'(state, voucher){
        state.voucher = voucher
    },
    'SET_PRODUCTO_VENTA'(state, productoVenta){
        state.productoVenta = productoVenta
    },
    'SET_SUCURSAL'(state, sucursales){
        state.sucursales = sucursales
    },
    'SET_BOLETAS'(state, boletas){
        state.boletas = boletas
    },
    'SET_FACTURAS'(state, facturas){
        state.facturas = facturas
    },
    'SET_NOTA_CREDITO'(state, nota_credito){
        state.nota_credito = nota_credito
    },
    'SET_INGRESOS'(state, ingresos){
        state.ingresos = ingresos
    },
    'SET_ENCARGO'(state, encargos){
        state.encargos = encargos
    },
    'SET_SALDOS_FAVOR'(state, saldos) {
      state.saldosFavor = saldos
    }
}
export {mutations}
